import * as Yup from 'yup';

export const TaxRegimechema = Yup.object().shape({
    name: Yup.string()
        .required('Name is required')
        .matches(/^[a-zA-Z0-9_ ]*$/, 'Name can only contain alphanumeric characters, underscores, and spaces'),
    appliedTaxes: Yup.array()
        .min(1, 'Tax cannot be an empty array')
        .required('Tax are required'),
    taxes: Yup.array().of(
        Yup.object().shape({
            name: Yup.string().required('Tax name is required'),
            rate: Yup.string().required('Tax rate is required'),
            taxType: Yup.string().required('Tax type is required'),
        })
    ),
    active: Yup.boolean(),
});
